import { render } from "./subHeaderComponent.vue?vue&type=template&id=2a5a347e"
import script from "./subHeaderComponent.vue?vue&type=script&lang=js"
export * from "./subHeaderComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__